var _rect, _path, _rect2, _rect3, _rect4, _g, _g2, _rect5, _path2, _rect6, _rect7, _rect8, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _rect9, _path3, _rect10, _rect11, _rect12, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbubbles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 8937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8935"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3827",
    x: 0.771679,
    y: 0.771679,
    width: 44.7574,
    height: 13.8902,
    rx: 2.31504,
    fill: "#FCC404",
    stroke: "black",
    strokeWidth: 1.54336
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3836",
    d: "M1.62695 3.17031C1.62695 2.31794 2.31794 1.62695 3.17031 1.62695H41.7543C42.6067 1.62695 43.2976 2.31794 43.2976 3.17031V10.8871C43.2976 11.7395 42.6067 12.4305 41.7543 12.4305H3.17031C2.31794 12.4305 1.62695 11.7395 1.62695 10.8871V3.17031Z",
    fill: "#FEE282"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3837",
    x: 11.5293,
    y: 7.70996,
    width: 11.3187,
    height: 1.55633,
    rx: 0.778163,
    fill: "#1A1A1A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3838",
    x: 23.7686,
    y: 7.70996,
    width: 17.4026,
    height: 1.55633,
    rx: 0.778163,
    fill: "#1A1A1A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3839",
    x: 11.5293,
    y: 4.38672,
    width: 8.48848,
    height: 1.54336,
    rx: 0.77168,
    fill: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 8927"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4220_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 7,
    height: 8
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath8219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8217",
    d: "M3.18359 3.18337H9.17407V10.8291H3.18359V3.18337Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4220_4655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8231",
    d: "M3.62161 9.15614C3.55539 9.45088 3.69764 9.75177 3.96201 9.89796C4.61508 10.2592 5.36604 10.4648 6.16509 10.4648C6.96434 10.4648 7.71546 10.2591 8.36853 9.89785C8.63295 9.75166 8.7752 9.45077 8.70894 9.15603C8.4474 7.99209 7.40821 7.12242 6.1653 7.12242C4.92233 7.12242 3.88308 7.99214 3.62161 9.15614Z",
    fill: "#FF8086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8235",
    d: "M8.70897 9.15603C8.44744 7.99209 7.40825 7.12242 6.16533 7.12242C5.8905 7.12242 5.62577 7.16504 5.37711 7.24386C6.25324 7.52152 6.92885 8.24942 7.13253 9.15603C7.19879 9.45077 7.05655 9.75166 6.79212 9.89785C6.35876 10.1376 5.88204 10.3083 5.37695 10.3964C5.63302 10.441 5.89629 10.4648 6.16512 10.4648C6.96438 10.4648 7.7155 10.2591 8.36856 9.89785C8.63299 9.75166 8.77523 9.45077 8.70897 9.15603Z",
    fill: "#E5646E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8239",
    d: "M6.16707 7.48535C5.3985 7.48535 4.77539 6.86229 4.77539 6.09367V4.39569C4.77539 3.94509 5.14065 3.57983 5.59125 3.57983H6.74289C7.19349 3.57983 7.55875 3.94509 7.55875 4.39569V6.09367C7.55875 6.86229 6.93569 7.48535 6.16707 7.48535Z",
    fill: "#F2CCBC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8243",
    d: "M6.74192 3.57787H5.59028C5.5875 3.57787 5.58482 3.57829 5.58203 3.57829C6.02879 3.58276 6.38969 3.94592 6.38969 4.39373V6.09172C6.38969 6.65167 6.0588 7.13406 5.58203 7.35492C5.7597 7.43716 5.95743 7.4834 6.1661 7.4834C6.93472 7.4834 7.55778 6.86034 7.55778 6.09172V4.39373C7.55778 3.94313 7.19252 3.57787 6.74192 3.57787Z",
    fill: "#ECAD9A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8247",
    d: "M6.74289 3.57677H5.59125C5.14065 3.57677 4.77539 3.94203 4.77539 4.39263V5.43066L5.95473 5.04218C6.38961 4.89888 6.86633 4.96467 7.2462 5.22031L7.55875 5.43066V4.39263C7.55875 3.94203 7.19349 3.57677 6.74289 3.57677Z",
    fill: "#B0500A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8251",
    d: "M6.74187 3.57677H5.59023C5.58744 3.57677 5.58482 3.57714 5.58203 3.57719C6.02879 3.58171 6.38964 3.94482 6.38964 4.39263V4.9684C6.69048 4.96278 6.98974 5.04843 7.24518 5.22031L7.55773 5.43066V4.39263C7.55773 3.94203 7.19247 3.57677 6.74187 3.57677Z",
    fill: "#9B3E09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8291",
    d: "M6.94946 7.24265C7.82754 7.51958 8.50488 8.24842 8.70929 9.15645C8.7755 9.45119 8.6331 9.75182 8.36878 9.89785C7.71561 10.2594 6.9647 10.4648 6.16544 10.4648C5.36619 10.4648 4.61528 10.2594 3.96211 9.89838C3.69779 9.75182 3.55538 9.45119 3.62159 9.15645C3.75244 8.57422 4.07771 8.06608 4.52542 7.70297C4.7766 7.49961 5.06614 7.34197 5.38143 7.24265",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8295",
    d: "M6.16707 7.48535C5.3985 7.48535 4.77539 6.86229 4.77539 6.09367V4.39569C4.77539 3.94509 5.14065 3.57983 5.59125 3.57983H6.74289C7.19349 3.57983 7.55875 3.94509 7.55875 4.39569V6.09367C7.55875 6.86229 6.93569 7.48535 6.16707 7.48535Z",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8299",
    d: "M4.77539 5.43066L5.95473 5.04212C6.38961 4.89888 6.86633 4.96467 7.2462 5.22031L7.55875 5.43066",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 8934"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3832",
    x: 6.99629,
    y: 41.2355,
    width: 41.6707,
    height: 13.8902,
    rx: 2.31504,
    fill: "#29A745",
    stroke: "black",
    strokeWidth: 1.54336
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3833",
    d: "M7.72656 43.5795C7.72656 42.7271 8.41755 42.0361 9.26992 42.0361H44.7672C45.6196 42.0361 46.3105 42.7271 46.3105 43.5795V51.2963C46.3105 52.1487 45.6196 52.8396 44.7672 52.8396H10.0416C8.76304 52.8396 7.72656 51.8032 7.72656 50.5246V43.5795Z",
    fill: "#94D3A2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3843",
    x: 16.9229,
    y: 48.332,
    width: 10.4698,
    height: 1.55633,
    rx: 0.778163,
    fill: "#1A1A1A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3844",
    x: 28.4531,
    y: 48.332,
    width: 14.5021,
    height: 1.55633,
    rx: 0.778163,
    fill: "#1A1A1A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3845",
    x: 16.9229,
    y: 45.0068,
    width: 8.48848,
    height: 1.54336,
    rx: 0.77168,
    fill: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 8928"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4220_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 43,
    width: 7,
    height: 9
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath8219_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8217_2",
    d: "M8.99902 43.5925H14.9895V51.2383H8.99902V43.5925Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4220_4655)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g8229_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8231_2",
    d: "M9.43703 49.5634C9.37082 49.8581 9.51307 50.159 9.77744 50.3052C10.4305 50.6664 11.1815 50.8721 11.9805 50.8721C12.7798 50.8721 13.5309 50.6663 14.184 50.3051C14.4484 50.1589 14.5906 49.858 14.5244 49.5633C14.2628 48.3993 13.2236 47.5296 11.9807 47.5296C10.7378 47.5296 9.69851 48.3994 9.43703 49.5634Z",
    fill: "#FF8086"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g8233_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8235_2",
    d: "M14.5244 49.5633C14.2629 48.3993 13.2237 47.5296 11.9808 47.5296C11.7059 47.5296 11.4412 47.5723 11.1925 47.6511C12.0687 47.9288 12.7443 48.6566 12.948 49.5633C13.0142 49.858 12.872 50.1589 12.6076 50.3051C12.1742 50.5449 11.6975 50.7155 11.1924 50.8036C11.4484 50.8483 11.7117 50.8721 11.9806 50.8721C12.7798 50.8721 13.5309 50.6663 14.184 50.3051C14.4484 50.1589 14.5907 49.858 14.5244 49.5633Z",
    fill: "#E5646E"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g8237_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8239_2",
    d: "M11.9825 47.8916C11.2139 47.8916 10.5908 47.2685 10.5908 46.4999V44.8019C10.5908 44.3513 10.9561 43.9861 11.4067 43.9861H12.5583C13.0089 43.9861 13.3742 44.3513 13.3742 44.8019V46.4999C13.3742 47.2685 12.7511 47.8916 11.9825 47.8916Z",
    fill: "#F2CCBC"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g8241_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8243_2",
    d: "M12.5564 43.9861H11.4047C11.4019 43.9861 11.3993 43.9865 11.3965 43.9865C11.8432 43.991 12.2041 44.3541 12.2041 44.8019V46.4999C12.2041 47.0599 11.8733 47.5423 11.3965 47.7631C11.5741 47.8454 11.7719 47.8916 11.9806 47.8916C12.7492 47.8916 13.3722 47.2685 13.3722 46.4999V44.8019C13.3722 44.3513 13.007 43.9861 12.5564 43.9861Z",
    fill: "#ECAD9A"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g8245_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8247_2",
    d: "M12.5583 43.986H11.4067C10.9561 43.986 10.5908 44.3512 10.5908 44.8018V45.8398L11.7702 45.4514C12.205 45.3081 12.6818 45.3738 13.0616 45.6295L13.3742 45.8398V44.8018C13.3742 44.3512 13.0089 43.986 12.5583 43.986Z",
    fill: "#B0500A"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g8249_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8251_2",
    d: "M12.5563 43.986H11.4047C11.4019 43.986 11.3993 43.9863 11.3965 43.9864C11.8432 43.9909 12.2041 44.354 12.2041 44.8018V45.3776C12.5049 45.372 12.8042 45.4576 13.0596 45.6295L13.3722 45.8398V44.8018C13.3722 44.3512 13.0069 43.986 12.5563 43.986Z",
    fill: "#9B3E09"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g8289_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8291_2",
    d: "M12.7649 47.6499C13.643 47.9268 14.3203 48.6556 14.5247 49.5637C14.5909 49.8584 14.4485 50.159 14.1842 50.3051C13.531 50.6666 12.7801 50.8721 11.9809 50.8721C11.1816 50.8721 10.4307 50.6666 9.77753 50.3056C9.51322 50.159 9.37081 49.8584 9.43702 49.5637C9.56787 48.9814 9.89314 48.4733 10.3408 48.1102C10.592 47.9068 10.8816 47.7492 11.1969 47.6499",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g8293_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8295_2",
    d: "M11.9825 47.8916C11.2139 47.8916 10.5908 47.2685 10.5908 46.4999V44.8019C10.5908 44.3513 10.9561 43.9861 11.4067 43.9861H12.5583C13.0089 43.9861 13.3742 44.3513 13.3742 44.8019V46.4999C13.3742 47.2685 12.7511 47.8916 11.9825 47.8916Z",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g8297_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8299_2",
    d: "M10.5908 45.8398L11.7702 45.4513C12.205 45.3081 12.6818 45.3738 13.0616 45.6295L13.3742 45.8398",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 8927_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4220_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 43,
    width: 7,
    height: 9
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath8219_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8217_3",
    d: "M8.99902 43.5925H14.9895V51.2383H8.99902V43.5925Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4220_4655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8229_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8231_3",
    d: "M9.43703 49.5634C9.37082 49.8581 9.51307 50.159 9.77744 50.3052C10.4305 50.6664 11.1815 50.8721 11.9805 50.8721C12.7798 50.8721 13.5309 50.6663 14.184 50.3051C14.4484 50.1589 14.5906 49.858 14.5244 49.5633C14.2628 48.3993 13.2236 47.5296 11.9807 47.5296C10.7378 47.5296 9.69851 48.3994 9.43703 49.5634Z",
    fill: "#FF8086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8233_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8235_3",
    d: "M14.5244 49.5633C14.2629 48.3993 13.2237 47.5296 11.9808 47.5296C11.7059 47.5296 11.4412 47.5723 11.1925 47.6511C12.0687 47.9288 12.7443 48.6566 12.948 49.5633C13.0142 49.858 12.872 50.1589 12.6076 50.3051C12.1742 50.5449 11.6975 50.7155 11.1924 50.8036C11.4484 50.8483 11.7117 50.8721 11.9806 50.8721C12.7798 50.8721 13.5309 50.6663 14.184 50.3051C14.4484 50.1589 14.5907 49.858 14.5244 49.5633Z",
    fill: "#E5646E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8237_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8239_3",
    d: "M11.9825 47.8916C11.2139 47.8916 10.5908 47.2685 10.5908 46.4999V44.8019C10.5908 44.3513 10.9561 43.9861 11.4067 43.9861H12.5583C13.0089 43.9861 13.3742 44.3513 13.3742 44.8019V46.4999C13.3742 47.2685 12.7511 47.8916 11.9825 47.8916Z",
    fill: "#F2CCBC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8241_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8243_3",
    d: "M12.5564 43.9861H11.4047C11.4019 43.9861 11.3993 43.9865 11.3965 43.9865C11.8432 43.991 12.2041 44.3541 12.2041 44.8019V46.4999C12.2041 47.0599 11.8733 47.5423 11.3965 47.7631C11.5741 47.8454 11.7719 47.8916 11.9806 47.8916C12.7492 47.8916 13.3722 47.2685 13.3722 46.4999V44.8019C13.3722 44.3513 13.007 43.9861 12.5564 43.9861Z",
    fill: "#ECAD9A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8245_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8247_3",
    d: "M12.5583 43.986H11.4067C10.9561 43.986 10.5908 44.3512 10.5908 44.8018V45.8398L11.7702 45.4514C12.205 45.3081 12.6818 45.3738 13.0616 45.6295L13.3742 45.8398V44.8018C13.3742 44.3512 13.0089 43.986 12.5583 43.986Z",
    fill: "#B0500A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8249_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8251_3",
    d: "M12.5563 43.986H11.4047C11.4019 43.986 11.3993 43.9863 11.3965 43.9864C11.8432 43.9909 12.2041 44.354 12.2041 44.8018V45.3776C12.5049 45.372 12.8042 45.4576 13.0596 45.6295L13.3722 45.8398V44.8018C13.3722 44.3512 13.0069 43.986 12.5563 43.986Z",
    fill: "#9B3E09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8289_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8291_3",
    d: "M12.7649 47.6499C13.643 47.9268 14.3203 48.6556 14.5247 49.5637C14.5909 49.8584 14.4485 50.159 14.1842 50.3051C13.531 50.6666 12.7801 50.8721 11.9809 50.8721C11.1816 50.8721 10.4307 50.6666 9.77753 50.3056C9.51322 50.159 9.37081 49.8584 9.43702 49.5637C9.56787 48.9814 9.89314 48.4733 10.3408 48.1102C10.592 47.9068 10.8816 47.7492 11.1969 47.6499",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8293_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8295_3",
    d: "M11.9825 47.8916C11.2139 47.8916 10.5908 47.2685 10.5908 46.4999V44.8019C10.5908 44.3513 10.9561 43.9861 11.4067 43.9861H12.5583C13.0089 43.9861 13.3742 44.3513 13.3742 44.8019V46.4999C13.3742 47.2685 12.7511 47.8916 11.9825 47.8916Z",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8297_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8299_3",
    d: "M10.5908 45.8398L11.7702 45.4513C12.205 45.3081 12.6818 45.3738 13.0616 45.6295L13.3742 45.8398",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 8933"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3834",
    x: 14.841,
    y: 20.9973,
    width: 39.3557,
    height: 13.8902,
    rx: 2.31504,
    fill: "#3374ED",
    stroke: "black",
    strokeWidth: 1.54336
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3835",
    d: "M15.6338 23.3324C15.6338 22.48 16.3248 21.7891 17.1771 21.7891H50.3594C51.2117 21.7891 51.9027 22.48 51.9027 23.3324V31.0492C51.9027 31.9016 51.2117 32.5926 50.3594 32.5926H17.9488C16.6703 32.5926 15.6338 31.5561 15.6338 30.2775V23.3324Z",
    fill: "#99BAF6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3840",
    x: 24.3369,
    y: 28.085,
    width: 14.9973,
    height: 1.55633,
    rx: 0.778163,
    fill: "#1A1A1A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3841",
    x: 40.3955,
    y: 28.085,
    width: 9.97464,
    height: 1.55633,
    rx: 0.778163,
    fill: "#1A1A1A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3842",
    x: 24.3369,
    y: 24.7607,
    width: 8.48848,
    height: 1.54336,
    rx: 0.77168,
    fill: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 8929"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4220_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 23,
    width: 7,
    height: 8
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath8219_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8217_4",
    d: "M17.0479 23.3465H23.0383V30.9922H17.0479V23.3465Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4220_4655)"
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "g8229_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8231_4",
    d: "M17.4868 29.3163C17.4206 29.611 17.5629 29.9119 17.8272 30.0581C18.4803 30.4193 19.2313 30.625 20.0303 30.625C20.8296 30.625 21.5807 30.4193 22.2338 30.058C22.4982 29.9118 22.6404 29.6109 22.5742 29.3162C22.3126 28.1522 21.2734 27.2826 20.0305 27.2826C18.7876 27.2826 17.7483 28.1523 17.4868 29.3163Z",
    fill: "#FF8086"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "g8233_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8235_4",
    d: "M22.5742 29.3162C22.3127 28.1522 21.2735 27.2826 20.0306 27.2826C19.7557 27.2826 19.491 27.3252 19.2423 27.404C20.1185 27.6817 20.7941 28.4096 20.9978 29.3162C21.064 29.6109 20.9218 29.9118 20.6574 30.058C20.224 30.2978 19.7473 30.4685 19.2422 30.5565C19.4983 30.6012 19.7615 30.625 20.0304 30.625C20.8296 30.625 21.5807 30.4193 22.2338 30.058C22.4982 29.9118 22.6405 29.6109 22.5742 29.3162Z",
    fill: "#E5646E"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "g8237_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8239_4",
    d: "M20.0323 27.6455C19.2637 27.6455 18.6406 27.0224 18.6406 26.2538V24.5558C18.6406 24.1052 19.0059 23.74 19.4565 23.74H20.6081C21.0587 23.74 21.424 24.1052 21.424 24.5558V26.2538C21.424 27.0224 20.8009 27.6455 20.0323 27.6455Z",
    fill: "#F2CCBC"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "g8241_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8243_4",
    d: "M20.6072 23.74H19.4555C19.4527 23.74 19.4501 23.7404 19.4473 23.7404C19.894 23.7449 20.2549 24.108 20.2549 24.5558V26.2538C20.2549 26.8138 19.924 27.2962 19.4473 27.517C19.6249 27.5993 19.8227 27.6455 20.0313 27.6455C20.8 27.6455 21.423 27.0224 21.423 26.2538V24.5558C21.423 24.1052 21.0578 23.74 20.6072 23.74Z",
    fill: "#ECAD9A"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "g8245_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8247_4",
    d: "M20.6081 23.7399H19.4565C19.0059 23.7399 18.6406 24.1051 18.6406 24.5557V25.5938L19.82 25.2053C20.2548 25.062 20.7316 25.1278 21.1114 25.3834L21.424 25.5938V24.5557C21.424 24.1051 21.0587 23.7399 20.6081 23.7399Z",
    fill: "#B0500A"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "g8249_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8251_4",
    d: "M20.6071 23.7399H19.4555C19.4527 23.7399 19.4501 23.7402 19.4473 23.7403C19.894 23.7448 20.2549 24.1079 20.2549 24.5557V25.1315C20.5557 25.1259 20.855 25.2115 21.1104 25.3834L21.423 25.5938V24.5557C21.423 24.1051 21.0577 23.7399 20.6071 23.7399Z",
    fill: "#9B3E09"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "g8289_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8291_4",
    d: "M20.8147 27.4028C21.6928 27.6797 22.3701 28.4086 22.5745 29.3166C22.6407 29.6113 22.4983 29.912 22.234 30.058C21.5808 30.4195 20.8299 30.625 20.0307 30.625C19.2314 30.625 18.4805 30.4195 17.8273 30.0585C17.563 29.912 17.4206 29.6113 17.4868 29.3166C17.6177 28.7344 17.9429 28.2262 18.3907 27.8631C18.6418 27.6598 18.9314 27.5021 19.2467 27.4028",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "g8293_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8295_4",
    d: "M20.0323 27.6455C19.2637 27.6455 18.6406 27.0224 18.6406 26.2538V24.5558C18.6406 24.1052 19.0059 23.74 19.4565 23.74H20.6081C21.0587 23.74 21.424 24.1052 21.424 24.5558V26.2538C21.424 27.0224 20.8009 27.6455 20.0323 27.6455Z",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "g8297_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8299_4",
    d: "M18.6406 25.5938L19.82 25.2052C20.2548 25.062 20.7316 25.1278 21.1114 25.3834L21.424 25.5938",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 8927_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4220_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 23,
    width: 7,
    height: 8
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath8219_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8217_5",
    d: "M17.0479 23.3465H23.0383V30.9922H17.0479V23.3465Z",
    fill: "white"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4220_4655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8229_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8231_5",
    d: "M17.4868 29.3163C17.4206 29.611 17.5629 29.9119 17.8272 30.0581C18.4803 30.4193 19.2313 30.625 20.0303 30.625C20.8296 30.625 21.5807 30.4193 22.2338 30.058C22.4982 29.9118 22.6404 29.6109 22.5742 29.3162C22.3126 28.1522 21.2734 27.2826 20.0305 27.2826C18.7876 27.2826 17.7483 28.1523 17.4868 29.3163Z",
    fill: "#FF8086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8233_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8235_5",
    d: "M22.5742 29.3162C22.3127 28.1522 21.2735 27.2826 20.0306 27.2826C19.7557 27.2826 19.491 27.3252 19.2423 27.404C20.1185 27.6817 20.7941 28.4096 20.9978 29.3162C21.064 29.6109 20.9218 29.9118 20.6574 30.058C20.224 30.2978 19.7473 30.4685 19.2422 30.5565C19.4983 30.6012 19.7615 30.625 20.0304 30.625C20.8296 30.625 21.5807 30.4193 22.2338 30.058C22.4982 29.9118 22.6405 29.6109 22.5742 29.3162Z",
    fill: "#E5646E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8237_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8239_5",
    d: "M20.0323 27.6455C19.2637 27.6455 18.6406 27.0224 18.6406 26.2538V24.5558C18.6406 24.1052 19.0059 23.74 19.4565 23.74H20.6081C21.0587 23.74 21.424 24.1052 21.424 24.5558V26.2538C21.424 27.0224 20.8009 27.6455 20.0323 27.6455Z",
    fill: "#A74921"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8241_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8243_5",
    d: "M20.6072 23.74H19.4555C19.4527 23.74 19.4501 23.7404 19.4473 23.7404C19.894 23.7449 20.2549 24.108 20.2549 24.5558V26.2538C20.2549 26.8138 19.924 27.2962 19.4473 27.517C19.6249 27.5993 19.8227 27.6455 20.0313 27.6455C20.8 27.6455 21.423 27.0224 21.423 26.2538V24.5558C21.423 24.1052 21.0578 23.74 20.6072 23.74Z",
    fill: "#843E29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8245_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8247_5",
    d: "M20.6081 23.7399H19.4565C19.0059 23.7399 18.6406 24.1051 18.6406 24.5557V25.5938L19.82 25.2053C20.2548 25.062 20.7316 25.1278 21.1114 25.3834L21.424 25.5938V24.5557C21.424 24.1051 21.0587 23.7399 20.6081 23.7399Z",
    fill: "#3A1B04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8249_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8251_5",
    d: "M20.6071 23.7399H19.4555C19.4527 23.7399 19.4501 23.7402 19.4473 23.7403C19.894 23.7448 20.2549 24.1079 20.2549 24.5557V25.1315C20.5557 25.1259 20.855 25.2115 21.1104 25.3834L21.423 25.5938V24.5557C21.423 24.1051 21.0577 23.7399 20.6071 23.7399Z",
    fill: "#270E00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8289_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8291_5",
    d: "M20.8147 27.4028C21.6928 27.6797 22.3701 28.4086 22.5745 29.3166C22.6407 29.6113 22.4983 29.912 22.234 30.058C21.5808 30.4195 20.8299 30.625 20.0307 30.625C19.2314 30.625 18.4805 30.4195 17.8273 30.0585C17.563 29.912 17.4206 29.6113 17.4868 29.3166C17.6177 28.7344 17.9429 28.2262 18.3907 27.8631C18.6418 27.6598 18.9314 27.5021 19.2467 27.4028",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8293_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8295_5",
    d: "M20.0323 27.6455C19.2637 27.6455 18.6406 27.0224 18.6406 26.2538V24.5558C18.6406 24.1052 19.0059 23.74 19.4565 23.74H20.6081C21.0587 23.74 21.424 24.1052 21.424 24.5558V26.2538C21.424 27.0224 20.8009 27.6455 20.0323 27.6455Z",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8297_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8299_5",
    d: "M18.6406 25.5938L19.82 25.2052C20.2548 25.062 20.7316 25.1278 21.1114 25.3834L21.424 25.5938",
    stroke: "black",
    strokeWidth: 0.78822,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbubbles);
export default __webpack_public_path__ + "static/media/chatbubbles.d74f9520.svg";
export { ForwardRef as ReactComponent };